/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Suggest_Quick_WorkoutInputs */

const en_us2_coach_suggest_quick_workout = /** @type {(inputs: Coach_Suggest_Quick_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build me a quick 30-minute workout for today`)
};

const pt_br2_coach_suggest_quick_workout = /** @type {(inputs: Coach_Suggest_Quick_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monte um treino rápido de 30 min para hoje`)
};

const es_419_coach_suggest_quick_workout = /** @type {(inputs: Coach_Suggest_Quick_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arma un entrenamiento rápido de 30 min para hoy`)
};

const pt_pt2_coach_suggest_quick_workout = /** @type {(inputs: Coach_Suggest_Quick_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monta-me um treino rápido de 30 min para hoje`)
};

const fr_fr2_coach_suggest_quick_workout = /** @type {(inputs: Coach_Suggest_Quick_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prépare-moi une séance rapide de 30 min pour aujourd'hui`)
};

const de_de2_coach_suggest_quick_workout = /** @type {(inputs: Coach_Suggest_Quick_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stell mir ein schnelles 30-Minuten-Training für heute zusammen`)
};

const it_it2_coach_suggest_quick_workout = /** @type {(inputs: Coach_Suggest_Quick_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparami un allenamento veloce di 30 minuti per oggi`)
};

/**
* | output |
* | --- |
* | "Build me a quick 30-minute workout for today" |
*
* @param {Coach_Suggest_Quick_WorkoutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_suggest_quick_workout = /** @type {((inputs?: Coach_Suggest_Quick_WorkoutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Suggest_Quick_WorkoutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_suggest_quick_workout(inputs)
	if (locale === "es-419") return es_419_coach_suggest_quick_workout(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_suggest_quick_workout(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_suggest_quick_workout(inputs)
	if (locale === "de-DE") return de_de2_coach_suggest_quick_workout(inputs)
	if (locale === "it-IT") return it_it2_coach_suggest_quick_workout(inputs)
	return en_us2_coach_suggest_quick_workout(inputs)
});
export { coach_suggest_quick_workout as "coach.suggest_quick_workout" }